import { Item, Voucher } from 'shared-types/Common';
import { ExperienceVoucherNormalizedSchema } from 'shared-types/Common.schema';
export const mapItemsWithVouchers = (items: Item[], vouchers?: Voucher[]): Item[] => {
  return items.map((item) => {
    const itemVoucher = vouchers?.find((voucher) => {
      const v = ExperienceVoucherNormalizedSchema.safeParse(voucher);
      if ('data' in v && v.data !== undefined) {
        return v.data.itemId === item.id;
      }
      return false;
    });

    const discountAmount = itemVoucher?.redemptionTotal?.amount;

    if (itemVoucher) {
      return {
        ...item,
        discount: {
          standardPrice: {
            prefix: item.price.prefix,
            currencyCode: item.price.currencyCode,
            amount: item.price.amount,
          },
          discountedPrice: {
            prefix: item.price.prefix,
            currencyCode: item.price.currencyCode,
            amount: item.price.amount - (discountAmount || 0),
          },
          name: `voucher-${itemVoucher.code}`,
          discountValue: {
            value: 100,
            type: 'percentage',
          },
        },
      };
    }
    return item;
  });
};
